<template>


    <div>
        <div style="color: #555">

            <b-input
                    v-model="newIssue.title" class="my-1 mt-2"
                    placeholder="عنوان" rows="2" title="عنوان"
                    :rules="rules"
            ></b-input>
            <b-textarea v-if="newIssue.title" title="توضیحات"
                        v-model="newIssue.intro" id="textarea-rows" class="my-1 mt-2"
                        placeholder="توضیحات ..." rows="2"
                        :rules="rules"
            ></b-textarea>


            <b-row  v-if="newIssue.title">

                <b-col  md="5">
                    <small> نوع:</small>

                    <b-form-select v-model="newIssue.type"  size="sm" class="mt-2" style="direction: ltr">

                        <b-form-select-option  v-for="(type, typeIndex) in types" :key="typeIndex"  :style="{color: typeBadgeStyles(type)}"
                                               :value="type.id"  >
                            {{type.title}}
                        </b-form-select-option>
<!--                        <b-form-select-option  value="1" style="color: #880e4e">سرنخ (Lead)</b-form-select-option>-->
<!--                        <b-form-select-option  value="2" style="color: #f50057">فرصت (Opportunity)</b-form-select-option>-->
<!--                        <b-form-select-option  value="3" style="color: #8e24aa">ملاقات/جلسه/رویداد</b-form-select-option>-->
<!--                        <b-form-select-option  value="4" style="color: #263238" >پیگیری (Ticket)</b-form-select-option>-->
<!--                        <b-form-select-option  value="5" style="color: #dd2c00">ایراد (Bug)</b-form-select-option>-->
<!--                        <b-form-select-option  value="6" style="color: #00c853">فعالیت (Task)</b-form-select-option>-->
<!--                        <b-form-select-option  value="7" style="color: #0097a7">لیست/شرح (Story)</b-form-select-option>-->
<!--                        <b-form-select-option  value="8" style="color: #0288d1">مجموعه/امکانات (Epic)</b-form-select-option>-->
<!--                        <b-form-select-option  value="9" style="color: #0208ff">پیام/تلفن (Message)</b-form-select-option>-->
<!--                        <b-form-select-option  value="10" style="color: #0e8e2e">گزارش/خبر (Report)</b-form-select-option>-->
                        <b-form-select-option  value="0" style="color: #888888">سایر</b-form-select-option>

                    </b-form-select>
                </b-col>

                <b-col  md="4">
                    <small> وضعیت:</small>

                    <b-form-select
                            v-c-tooltip="{
        content: '<strong>وضعیت</strong>',
        placement: 'left'
      }"
                            v-model="newIssue.board_id"  size="sm" class="mt-2"  style="direction: ltr">

                        <b-form-select-option  value="1"  style="color: #ffab00">(Open) باز شده</b-form-select-option>
                        <b-form-select-option  value="2"  style="color: #ffd600">(To DO) جهت انجام</b-form-select-option>
                        <b-form-select-option  value="3"  style="color: #aeea00">درحال انجام (Doing)</b-form-select-option>
<!--                        <b-form-select-option  value="4"  style="color: #64dd17">جهت بازبینی (Review)</b-form-select-option>-->
                        <b-form-select-option  value="4"  style="color: #00bfa5">انجام شده (Done)</b-form-select-option>
<!--                        <b-form-select-option  value="5"  style="color: #64dd17">آرشیو (Archived)</b-form-select-option>-->





                    </b-form-select>
                </b-col>

                <b-col  md="3">
                    <small> اولویت:</small>

                    <b-form-select title="اولویت" v-model="newIssue.priority"  size="sm" class="mt-2"  style="direction: ltr">

                        <b-form-select-option  value="3" >  اولویت زیاد</b-form-select-option>
                        <b-form-select-option  value="2" >  اولویت متوسط</b-form-select-option>
                        <b-form-select-option  value="1" >  اولویت کم</b-form-select-option>



                    </b-form-select>
                </b-col>



                <!--                                                  <b-col  md="5" class="mt-3 mb-2">-->
                <!--                                                      &lt;!&ndash;                                                          <b-form-select v-model="newIssue.type"  size="sm" class="mt-2"  style="direction: ltr">&ndash;&gt;-->
                <!--                                                      &lt;!&ndash;                                                              <b-form-select-option  value="null" >پروژه نامشخص</b-form-select-option>&ndash;&gt;-->
                <!--                                                      &lt;!&ndash;                                                          </b-form-select>&ndash;&gt;-->

                <!--                                                      <multiselect v-model="newIssue.project_id"  @select="setForumId($event)"  :options="options"-->
                <!--                                                                   placeholder=" انتخاب پروژه" label="title" track-by="title">-->
                <!--                                                      </multiselect>-->
                <!--                                                  </b-col>-->





                <b-col  md="12" class="mt-3 mb-2">
                    <small> اختصاص کاربر:</small>

                    <multiselect   v-model="newIssue.users" :height="300" :options="assignOptions" :multiple="true"
                                   :taggable="true" :close-on-select="false" :clear-on-select="false"
                                   :custom-label="customLabelAssign"
                                   :preserve-search="true" :hide-selected="true" :show-labels="false"
                                   tag-placeholder="اختصاص کاربر" placeholder="اختصاص کاربر"
                                   label="name" track-by="name" :preselect-first="false"
                                   @tag="addAssign">

                    </multiselect>
                </b-col>





              <b-col  md="6" class="mb-2">

                <small> فرایند:</small>
                <b-form-select  size="sm" style="direction: ltr"
                                v-model="newIssue.process_id"
                >
                  <b-form-select-option  v-for="(process, processIndex) in processes" :key="processIndex"
                                         :value="process.id"  >
                    {{process.title}}
                  </b-form-select-option>

                </b-form-select>
              </b-col>
              <b-col  md="6" class="mb-2" >

                <small> مرحله:</small>
                <b-form-select  size="sm" style="direction: ltr"
                                v-model="newIssue.step_id"
                >
                  <b-form-select-option  v-for="(step, stepIndex) in steps" :key="stepIndex"   :value="step.id" >
                    {{step.title}}
                  </b-form-select-option>

                </b-form-select>
              </b-col>







            </b-row>



          <b-row  v-if="newIssue.title" class="pb-2">

<!--            <b-col  md="12" class="mt-2">-->
<!--              <br><hr>-->
<!--            </b-col>-->

            <b-col v-if="returnIssueFields(newIssue.fields, newIssue.field_values, newIssue.type_object)"  md="3" sm="12" class="mt-2"
                   v-for="(field, fieldIndex) in returnIssueFields(newIssue.fields, newIssue.field_values, newIssue.type_object)" :key="fieldIndex" >

              <small v-if="field.type !== 'space'">{{field.title}}:</small>


              <b-input v-if="field.type === 'input'"
                       v-model="field.pivot.value"
                       :placeholder="field.title"
                       type="text"
                       size="sm"
              ></b-input>
              <b-input v-else-if="field.type === 'input-number'"
                       v-model="field.pivot.value"
                       :placeholder="field.title"
                       type="number"
                       size="sm"
              ></b-input>
              <!--                                          <small> </small>-->
              <custom-time-picker v-else-if="field.type === 'date'"
                                  v-model="field.pivot.value"  :lable="field.title"
                                  type="date" :clearable="true" :placeholder="field.title" min="" max=""
                                  size="sm" input-class="form-control form-control-sm">
              </custom-time-picker>
              <custom-time-picker v-else-if="field.type === 'datetime'"
                                  v-model="field.pivot.value"  :lable="field.title"
                                  type="datetime" :clearable="true" :placeholder="field.title" min="" max=""
                                  size="sm" input-class="form-control form-control-sm">
              </custom-time-picker>


              <b-form-select v-else-if="field.type === 'option-true-false'"  size="sm"
                             v-model="field.pivot.value" style="direction: ltr">
                <b-form-select-option value="1"> تأیید</b-form-select-option>
                <b-form-select-option value="0">عدم تأیید </b-form-select-option>
              </b-form-select>
              <b-form-checkbox v-else-if="field.type === 'check-box'"  size="sm"
                               v-model="field.pivot.value" style="direction: ltr">
              </b-form-checkbox>



              <b-form-select v-else-if="field.type === 'option'"  size="sm"
                             v-model="field.pivot.value" style="direction: ltr">
                <b-form-select-option  v-for="(option, optionIndex) in JSON.parse(field.options)" :key="optionIndex"
                                       :value="option.value">
                  {{option.title}}
                </b-form-select-option>
              </b-form-select>
              <b-form-radio-group
                  v-else-if="field.type === 'radio'"
                  v-model="field.pivot.value"
                  :name="field.title"
              >
                <b-form-radio  v-for="(option, optionIndex) in JSON.parse(field.options)" :key="optionIndex" :value="option.value">
                  {{option.title}}
                </b-form-radio>
              </b-form-radio-group>


              <b-form-textarea v-else-if="field.type === 'textarea'"  size="sm" v-model="field.pivot.value"></b-form-textarea>

              <br v-else-if="field.type === 'space'">

            </b-col>




          </b-row>


        </div>


        <div class="row my-2">
            <div class="col-6 " style="display: flex;justify-content: right">
                <b-button @click="createIssue(parent_id)" variant="primary btn-sm px-1 mt-0"
                >ثبت پست (Issue) </b-button>
            </div>

            <b-row   v-if="newIssue.title" class="ul-upload mt-1 mb-0 col-6  text-left" style="color: #666">
                <b-col class="li-upload mr-1 mt-2 c-pointer"  @click="showVoiceRecorder = !showVoiceRecorder"><i class="fas fa-microphone"></i></b-col>
                <b-col class="li-upload mr-1 mt-2 c-pointer"  @click="showImageUploader = !showImageUploader"><i class="fas fa-image"></i></b-col>
                <b-col class="li-upload mr-1 mt-2 c-pointer"  @click="showVideoUploader = !showVideoUploader"><i class="fas fa-film"></i></b-col>
                <b-col class="li-upload mr-1 mt-2 c-pointer"  @click="showFileUploader = !showFileUploader"><i class="fas fa-paperclip"></i></b-col>
                <b-col class="li-upload mr-2" title="نمایش سایر فیلد ها" >
                    <b-button v-b-toggle.collapse-1  size="sm" >
                        <i class="fas fa-bars" aria-hidden="true"></i>
                    </b-button>
                </b-col>
            </b-row>

            <div v-if="showVoiceRecorder" class="d-flex justify-content-center w-100 px-2 my-1">
                <!--                                                <audio-recorder-->
                <!--                                                        v-model="newIssue.voice"-->
                <!--                                                        :attempts="1"-->
                <!--                                                        :time="2"-->
                <!--                                                        :show-upload-button="false"-->
                <!--                                                        :before-recording="callback"-->
                <!--                                                        :pause-recording="callback"-->
                <!--                                                        :after-recording="callback"-->
                <!--                                                        :select-record="callback"-->
                <!--                                                        :before-upload="callback"-->
                <!--                                                        :successful-upload="callback"-->
                <!--                                                        :failed-upload="callback"/>-->

                <vue-record-audio  v-model="newIssue.voice" @result="onResult"  />

                <audio  :src="srcPlay"  controls class="w-100 mr-2 mt-1">
                </audio>

            </div>





            <div v-if="showFileUploader" class="d-flex justify-content-center w-100 px-5 my-1" >

                <div class="ar">
                    <label>فایل را انتخاب کنید</label>

                    <b-form-file v-model="newIssue.file" placeholder="فایل را انتخاب کنید" drop-placeholder="Drop file here..."
                                 plain>
                    </b-form-file>
                    <!--                                                          <div class="text-center my-2" v-if="newIssue.file">-->
                    <!--                                                              <b-form-checkbox v-model="newIssue.fileLib"  :disabled="IssueAsForum" name="check-button" switch class="d-inline" ></b-form-checkbox>-->
                    <!--                                                              <span  class="mr-1"  style="color: #e65100">انتشار فایل در کتابخانه</span>-->
                    <!--                                                          </div>-->
                </div>

            </div>




            <div v-if="showImageUploader" class="d-flex justify-content-center w-100 px-5 my-1">

                <div class="ar " >
                    <label>تصویر را انتخاب کنید</label>
                    <!-- <ckeditor value="Hello, World!"></ckeditor> -->
                    <!--                                                    <ckeditor id="editor"  v-model="editorData" :config="editorConfig"></ckeditor>-->
                    <b-form-file v-model="newIssue.image" placeholder="تصویر را انتخاب کنید" drop-placeholder="Drop file here..." plain>
                    </b-form-file>

                    <!--                                                    <input type="file" class="" ref="file" @change="onFileChangeImage($event)"-->
                    <!--                                                           placeholder="تصویر را انتخاب کنید"/>-->


                </div>

            </div>



            <div v-if="showVideoUploader" class="d-flex justify-content-center w-100 px-5 my-1">

                <div class="ar" >
                    <label>ویدئو را انتخاب کنید</label>
                    <!-- <ckeditor value="Hello, World!"></ckeditor> -->
                    <!--                                                    <ckeditor id="editor"  v-model="editorData" :config="editorConfig"></ckeditor>-->
                    <b-form-file  v-model="newIssue.video" placeholder="ویدئو را انتخاب کنید" drop-placeholder="Drop file here..." plain>
                    </b-form-file>
                </div>

            </div>





        </div>



        <div>

            <b-collapse id="collapse-1" class="mt-2 text-right">
                <b-card style="color: #555">
                    <!--                                                          <b-form-select v-model="selected" :options="typeOptions" size="sm" class="mt-3"></b-form-select>-->



                    <b-row  v-if="newIssue.title">




                        <b-col  md="3">
                            <small> زمان شروع:</small>
                            <custom-time-picker  v-model="newIssue.start_date"
                                                 type="datetime" :clearable="true" placeholder="زمان شروع" min="" max="">
                            </custom-time-picker>
                        </b-col>
                        <b-col  md="3">
                            <small> زمان انجام:</small>
                            <custom-time-picker  v-model="newIssue.done_date"
                                                 type="datetime" :clearable="true" placeholder="زمان انجام" min="" max="">
                            </custom-time-picker>
                        </b-col>

                        <b-col  md="3" >
                            <small> مدت تخمینی:</small>
                            <b-input
                                    v-model="newIssue.estimated_time"
                                    placeholder="مدت تخمینی"
                                    type="number"
                            ></b-input>
                        </b-col>

                        <b-col  md="3" >
                            <small> درصد پیشرفت:</small>
                            <b-input
                                    v-model="newIssue.progress_input"
                                    placeholder="درصد پیشرفت"
                                    type="number"
                            ></b-input>
                        </b-col>

                      <b-col  md="6" class="mt-3 mb-2">
                        <small> مشتری:</small>

                        <v-select
                            v-model="newIssue.contact_id"
                            :options="contacts" label="last_name" :reduce="contact => contact.id" value="id">
                        </v-select>


                        <!--                            <multiselect  v-model="contact_id"  @select="setContactId()"    :options="contactOptions" :custom-label="customLabel"-->
                        <!--                                         placeholder=" انتخاب مشتری" label="title" track-by="title">-->
                        <!--                            </multiselect>-->
                      </b-col>

                      <b-col  md="6" class="mt-3 mb-2">
                        <small> پروژه:</small>

                        <v-select
                            v-model="newIssue.project_id"
                            :options="projects" label="title" :reduce="project => project.id" value="id">
                        </v-select>

                      </b-col>

                        <b-col  md="12" class="mt-2">

                            <multiselect  v-model="newIssue.tags" :height="300" :options="options" :multiple="true"
                                          :taggable="true" :close-on-select="false" :clear-on-select="false"
                                          :custom-label="customLabel"
                                          :preserve-search="true" :hide-selected="true" :show-labels="false"
                                          tag-placeholder="افزودن تگ جدید" placeholder="برچست (تگ)"
                                          label="title" track-by="title" :preselect-first="false"

                                          @tag="addTag">
                            </multiselect>
                        </b-col>
                    </b-row>








                </b-card>
            </b-collapse>
        </div>



    </div>



</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>

import Multiselect from 'vue-multiselect'

export default {
  name: 'addIssue',
  components: {

      Multiselect,

  },


    props: {
        parent_id: null,
        reply_id: null,
        sprint_id: null,
        board_id: null,
        process_id: null,
        section_id: null,
        step_id: null,
        type: null,
        contact_id: null,
        project_id: null
    },


  data () {
    return {

        auth: {
            headers: {
                Authorization: 'bearer ' + localStorage.getItem('token')
            }
        },


        role: localStorage.getItem('role'),
        authUser:
            {
                id:localStorage.getItem('id'),
            },



        loadMore: true,
        page: 1,
        pageSize: 10,
        voice: '',

        issues:[],
        issueText: 0,
        newIssue: {
            intro:'',
            state:'0',
            title:'',
            text:'0',


            progress_input:'',

            voice:'',
            file:'',
            image:'',
            video:'',

            news:0,
            course_id:null,
            course_category_id:null,
            forum_id:null,
            forum_category_id:null,
            tagsArray:[],
            // issue_likes:null,
            // userLike:null,

            type:'4',
            project_id:null,
            process_id:'',
            board_id:2,
            users:[],
            oldUsers:[],

            priority:2,
            start_date:null,
            done_date:null,
            tags:[],

            // parent_id:null

            fields:[],
            fieldWithVariable:[],
            field_values:[],

        },
        rules: [v => v.length <= 300 || 'تعداد حروف بیشتر از 300 کاراکتر است!'],

        showVoiceRecorder: false,
        showFileUploader: false,
        showImageUploader: false,
        showVideoUploader: false,

        src: null,
        srcPlay: null,

        issueAsCourse: false,
        issueAsForum: false,

        courseDisabled: false,
        forumDisabled: false,

        newComment:'',
        newReply:'',

        options:[],
        assignOptions:[],

        selectedTags: [],
        tags: [],
        isLoading: false,



        typeOptions: [
            { value: 'ticket', text: 'پیگیری (Ticket)' , selected :true},
            { value: 'bug', text: 'ایراد (Bug)' },
            { value: 'task', text: 'فعالیت (Task)' },
            { value: 'story', text: 'لیست (Story)' },
            { value: 'epic', text: 'نسخه/فیچر (Epic)' },
            { value: 'lead', text: 'سرنخ/فرصت (Lead)' },
            { value: 'meeting', text: 'ملاقات/جلسه/رویداد' },

        ],


        warningModal: false,

        // contact_id: '',
        contacts: [],
        projects: [],
        users:[],

        steps: [],
        orders: [],
        processes: [],

        types: [],

        fields: [],


    }
  },



  computed: {
    issueProcessId: function() {
      return this.newIssue.process_id;
    },
    issueType: function() {
      return this.newIssue.type;
    }
  },


  watch: {
    issueProcessId: function() {
      this.getSteps(this.newIssue.process_id)
    },
    issueType: function() {
      // this.getFields(this.newIssue.type)
      this.newIssue.type_object = this.types.find(x => x.id == this.newIssue.type)
    },

    // newIssue: {
    //         deep: true,
    //         handler(newValue, oldValue) {
    //
    //           console.log('newValue, oldValue',newValue.process_id, oldValue.process_id)
    //           // if(newValue.process_id !== oldValue.process_id)
    //               this.getSteps(this.newIssue.process_id)
    //
    //           // if(newValue.type !== oldValue.type)
    //               this.getFields(this.newIssue.type)
    //
    //         }
    //     }

        },




    mounted() {
        this.getTypes()
        this.getProcesses()
        this.getSteps()
        this.getOrders()
        this.getContacts()
        this.getProjects()
        this.getUsers()


        if(this.sprint_id)
            this.newIssue.sprint_id = this.sprint_id
        if(this.board_id)
            this.newIssue.board_id = this.board_id
        if(this.process_id)
            this.newIssue.process_id = this.process_id
        if(this.step_id)
            this.newIssue.step_id = this.step_id
        if(this.contact_id)
            this.newIssue.contact_id = this.contact_id
        if(this.project_id)
            this.newIssue.project_id = this.project_id
        if(this.type)
            this.newIssue.type = this.type


    },



    methods: {

        pluck(array, key) {
            return array.map(function (obj) {
                return obj[key];
            });
        },



        onResult (data) {
//                console.log('The blob data:', data);
//                console.log('Downloadable audio', window.URL.createObjectURL(data));
            this.srcPlay =  window.URL.createObjectURL(data)
            this.src =  data

        },

        createIssue(parentID = null){
            var app = this;

            if(parentID)
                app.newIssue.parent_id = parentID



          console.log('issue.fields',this.newIssue.fields, this.newIssue.field_values, this.newIssue.type_object);
          if (this.newIssue.fields)
            this.newIssue.fieldWithVariable = JSON.stringify(app.returnIssueFields(this.newIssue.fields, this.newIssue.field_values, this.newIssue.type_object))
          else
            this.newIssue.fieldWithVariable = []



          if(app.newIssue.tags){
                if(app.newIssue.tags.length !==0){
                    app.newIssue.tagsArray = app.pluck(app.newIssue.tags,"title")
                }
            }



            if(app.newIssue.users){
                if(app.newIssue.users.length !==0){
                    app.newIssue.oldUsers = app.newIssue.users
                    app.newIssue.users = app.pluck(app.newIssue.users,"id")
                }
            }


            if (app.newIssue.title.length == 0)
                if(app.src == null
                    && app.newIssue.image == ''
                    && app.newIssue.video == ''
                    && app.newIssue.file == ''){
                    app.$snotify.error('ورودی های پست (Issue) خالی است')
                    return false}
                else
                    app.newIssue.intro = '-'



            if (app.newIssue.title.length > 100 || app.newIssue.intro.length > 300){
                app.$snotify.error('تعداد حروف بیشتر از  کاراکتر مجاز است! متن رو کوتاه تر نمایید. ');
            }else {

                var newItem = app.newIssue;
                let formData = new FormData();
                for (const key in newItem) {
                    if (newItem.hasOwnProperty(key)) {
                        const element = newItem[key];
                        formData.append(key, element)
                        console.log(key, element);
                    }
                }

                if(app.src != null)
                    formData.append("voice",app.src, "filename.wav");


                axios.post(`/api/intro/store`,  formData , app.auth)
                    .then(function (resp) {
                        app.$snotify.success('پست (Issue) با موفقیت ثبت شد');

                        app.$parent.getIssues() //need to consider

                        // app.newIssue.parent_id = null
                    })
                    .catch(
                        e => {
                            console.log(e.responsere);
                            console.log(e,"IssueCreate");
                            // app.$snotify.error('امکان ثبت پست (Issue) وجود ندارد');
                        }
                    )
                    .finally(function (resp) {

                        app.newIssue.title = ''
                        app.newIssue.intro = ''


                        app.newIssue.progress_input = ''

                        app.newIssue.voice = ''
                        app.newIssue.file = ''
                        app.newIssue.image = ''
                        app.newIssue.video = ''
                        app.newIssue.news = 0
                        app.newIssue.course_id = null
                        app.newIssue.course_category_id = null
                        app.newIssue.forum_id = null
                        app.newIssue.forum_category_id = null
                        app.newIssue.tagsArray = null
                        app.src = null

                        app.newIssue.users = []

                        if(app.newIssue.oldUsers){
                            if(app.newIssue.oldUsers.length !==0){
                                app.newIssue.users = app.newIssue.oldUsers
                            }
                        }
                        // app.setOwnUserAssign()

                        // if(app.newIssue.tags){
                            //     if(app.newIssue.tags.length !==0){
                            //         app.newIssue.tagsArray = app.pluck(app.newIssue.tags,"title")
                            //     }
                            // }

                        }

                    )

            }


        },

        customLabel(option) {

            return `${option.title}`

        },

        addTag(newTag) {
            this.options.push({
                title: '#'+newTag,
                id: 0
            })
        },



        customLabelAssign(option) {

            return `${option.name}`

        },

        addAssign (newTag) {

            this.assignOptions.push({
                name: '@'+newTag,
                id: 0
            })
        },


        ajaxFindTag(query){

        },

        limitText (count) {
            return `and ${count} other tags`
        },

        asyncFind (query) {
            this.isLoading = true
            this.ajaxFindTag(query).then(response => {
                this.tags = response
                this.isLoading = false
            })
        },

        clearAll () {
            this.selectedTags = []
        },

        getProcesses(){
            var app = this;
            axios.get('/api/intro/processes', app.auth)
                .then(function (response) {
                    app.processes = response.data.data.data
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        getSteps(processID = null){
            var app = this;
            axios.get('/api/intro/steps/'+processID ,  app.auth)
                .then(function (response) {
                    app.steps = response.data.data.data
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        getOrders(){

            axios.get('/api/orders', this.auth)
                .then(response => {
                    // this.current_page = response.data.current_page
                    this.orders = response.data.data;
                    console.log(response.data.data)
                    // this.pagnationDate = response.data
                    // console.log(this.pagnationDate)
                    // this.loader = false
                })
                .catch(error => {
                    // this.loader = false
                    console.log(error);
                })
        },

        getContacts(){

            axios.get('/api/contactslist', this.auth)
                .then(response => {
                    // this.current_page = response.data.current_page
                    this.contacts = response.data;
                    // this.pagnationDate = response.data
                    // console.log(this.pagnationDate)
                    // this.loader = false

                    this.makeContactOptions()

                })
                .catch(error => {
                    // this.loader = false
                    console.log(error);
                })
        },

        makeContactOptions(){
            var app = this;

            for (const key in app.contacts) {
                if (app.contacts.hasOwnProperty(key)) {
                    const element = app.contacts[key];

                    app.contactOptions.push({
                        value: element.id,
                        text: element.first_name+' '+element.last_name
                    })
                    // this.details[0].
                }
            }
            // console.log(app.contacts)
            // console.log(app.contactOptions)


        },

        getProjects() {
            axios
                .get('/api/projectList', this.auth)
                .then(response => {

                    this.projects = response.data;
                })
                .catch(error => {
                    console.log(error);
                    this.errored = true
                })
        },

        addOrder(issueId ,orderId){

            var app = this;

            var params= {
                order_id: orderId,
                // state: state,
            }

            axios.post(`/api/issue/addOrder/`+issueId,  params , app.auth)
                .then(function (resp) {
                    // console.log(resp,"")
                    // app.items.push(app.timing);
                    app.$snotify.success(' با موفقیت ثبت شد');

                    app.getStepsWithIssues()
                })
                .catch(
                    e => {
                        console.log(e);
                        app.$snotify.error('امکان ثبت وجود ندارد');
                    }
                );


        },

        changeContact(issueId ,contactId){

            var app = this;

            var params= {
                contact_id: contactId,
                // state: state,
            }

            axios.post(`/api/issue/changeContact/`+issueId,  params , app.auth)
                .then(function (resp) {
                    // console.log(resp,"")
                    // app.items.push(app.timing);
                    app.$snotify.success(' با موفقیت ثبت شد');

                    app.getStepsWithIssues()
                })
                .catch(
                    e => {
                        console.log(e);
                        app.$snotify.error('امکان ثبت وجود ندارد');
                    }
                );


        },

        setContactId(){

            // console.log(event)

            // this.newPost.contact_id = event.value
            this.newPost.contact_id = this.contact_id

            console.log(this.newPost.contact_id)
        },




      returnIssueFields(fields, field_values , type_object){

          // return fields
        var combinedFieldAndValue = []
        // if (field_values.length !== 0){
        //     if (type_object)
        //         combinedFieldAndValue = _.map(field_values, function(item){
        //             return _.extend(item, _.find(type_object.fields , { id: item.id, value: item.value }));
        //         });
        //     else
        //         combinedFieldAndValue = field_values
        // }else {
        if (type_object)
          combinedFieldAndValue = _.map(type_object.fields, function(item){
            return _.extend(item, _.find(field_values , { id: item.id, value: 'www' }));
          });
        else
          combinedFieldAndValue = []
        // }


        combinedFieldAndValue.forEach(function (element) {
          if (!element.pivot.value)
            element.pivot.value = '';
        });

        return combinedFieldAndValue
      },







      getTags(){
            var app = this;
            axios.get('/home/file/tagSearch/', app.auth)
                .then(function (response) {
                    app.fileCategories = response.data.data.tags.data

                    console.log(response.data.data.tags.data)


                    for (const key in app.fileCategories) {
                        if (app.fileCategories.hasOwnProperty(key)) {
                            const element = app.fileCategories[key];

                            app.options.push({
                                title: '#'+element.title,
                                id: element.id
                            })
                            // this.details[0].
                        }
                    }
                    // console.log(app.options)


                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },


        getUsers(){
            var app = this;
            axios.get('/api/userslist', app.auth)
                .then(function (response) {
                    app.users = response.data

                    // console.log('users',response.data)


                    for (const key in app.users) {
                        if (app.users.hasOwnProperty(key)) {
                            const element = app.users[key];

                            app.assignOptions.push({
                                name: '@'+element.name,
                                id: element.id
                            })
                        }
                    }

                    app.setOwnUserAssign()

                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },


        setOwnUserAssign(){

            var ownUser = this.assignOptions.find(x => x.id == this.authUser.id)

            this.newIssue.users.push(ownUser)
        },




        getTypes(){
            var app = this;
            axios.get('/api/issueTypeList', app.auth)
                .then(function (response) {
                    app.types = response.data
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },


        typeBadgeStyles(issueType){
            if (issueType.type == 1)
                return '#880e4e'
            else if (issueType.type == 2)
                return '#f50057'
            else if (issueType.type == 3)
                return '#8e24aa'
            else if (issueType.type == 4)
                return '#263238'
            else if (issueType.type == 5)
                return '#dd2c00'
            else if (issueType.type == 6)
                return '#00c853'
            else if (issueType.type == 7)
                return '#0097a7'
            else if (issueType.type == 8)
                return '#0288d1'
            else if (issueType.type == 9)
                return '#0208ff'
            else if (issueType.type == 10)
                return '#eeb600'
            else if (issueType.type == 10)
                return '#0e8e2e'
            else
                return '#888888'
        },






      getFields(issueType = null){

        axios.get('/api/fieldList', this.auth)
            .then(response => {
              console.log(response.data);

              this.fields = response.data;
              this.newIssue.fields = response.data;

              // this.fields.forEach(function (element) {
              //     element.number = "1";
              // });
            })
            .catch(error => {
              console.log(error);
              this.errored = true
            })
            .finally(() => this.loading = false);

      },





    }
}
</script>











<style scoped>


    tr{
        box-shadow: 0px 4px 4px rgba(0,0,0,.15);

    }



</style>
